import { render, staticRenderFns } from "./planOptimizer.vue?vue&type=template&id=a3530e08&"
import script from "./planOptimizer.vue?vue&type=script&lang=js&"
export * from "./planOptimizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports